"use strict";
/// <reference path="irep.js"/>

IREP.certification = (function () {
    var init = function (options) {
        $(".action > div").hover(function () {
            $(this).css({ "cursor": "pointer" });
        });


    };


    return {
        init: init
    };
})();